import { FETCH_COMP_BU_FIN_FAILURE, FETCH_COMP_BU_FIN_REQUEST, FETCH_COMP_BU_FIN_SUCCESS } from "../actions/companyBuFinancialsActions";

  const initialState = {
    data: {},
    loading: true,
    error: null,
  };
  
  const companyBuFinancialsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_COMP_BU_FIN_REQUEST:
        return { ...state, loading: true , payload: action.payload};
      case FETCH_COMP_BU_FIN_SUCCESS:
        return { ...state, loading: false, data: action.payload };
      case FETCH_COMP_BU_FIN_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default companyBuFinancialsReducer;
  